import { QueryFunction, MutationFunction } from '@tanstack/react-query';
import { OrderDto, CreateOrderDto, UpdateOrderDto } from 'desk-common';
import api from './api';

export const getOrdersList: QueryFunction<
  OrderDto[],
  readonly [string, Partial<OrderDto>]
> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const hasFilters = params && Object.keys(params).length > 0;

  const response = await api.get('/orders', {
    params: hasFilters ? { filters: JSON.stringify(params) } : undefined,
  });

  return response.data;
};

export const createOrder: MutationFunction<number, CreateOrderDto> = async (
  data
) => {
  const response = await api.post<number>('/orders', data);
  return response.data;
};

export const updateOrder: MutationFunction<
  void,
  UpdateOrderDto & { id: number }
> = async ({ id, ...data }) => {
  const response = await api.put(`/orders/${id}`, data);
  return response.data;
};
